"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Checkbox = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

var _Checkbox2 = _interopRequireDefault(require("../../theme/icons/Checkbox"));

var Checkbox = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Checkbox, _PureComponent);

  var _super = (0, _createSuper2["default"])(Checkbox);

  function Checkbox() {
    (0, _classCallCheck2["default"])(this, Checkbox);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          label = _this$props.label,
          disabled = _this$props.disabled,
          rounded = _this$props.rounded,
          checked = _this$props.checked,
          indeterminate = _this$props.indeterminate,
          value = _this$props.value,
          onChange = _this$props.onChange;

      var iconElement = /*#__PURE__*/_react["default"].createElement(_Checkbox2["default"], {
        fill: _colors["default"].blackberry[400],
        rounded: rounded,
        checked: checked,
        indeterminate: indeterminate,
        disabled: disabled
      });

      return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          id: id,
          disabled: disabled,
          color: "primary",
          checked: checked,
          checkedIcon: iconElement,
          icon: iconElement,
          indeterminateIcon: iconElement,
          value: value,
          onChange: onChange
        }),
        label: label
      });
    }
  }]);
  return Checkbox;
}(_react.PureComponent);

exports.Checkbox = Checkbox;
Checkbox.defaultProps = {
  disabled: false,
  indeterminate: false,
  label: '',
  rounded: false,
  onChange: null
};
var _default = Checkbox;
exports["default"] = _default;